'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import ContactFormModal from './ContactFormModal';
interface ContactButtonProps {
  label: string;
  variant?: 'primary' | 'outline';
  className?: string;
}
export default function ContactButton(t0) {
  const $ = _c(11);
  const {
    label,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "outline" : t1;
  const [open, setOpen] = useState(false);
  const t2 = variant === "primary" ? "default" : "outline";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpen(true);
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== className || $[2] !== label || $[3] !== t2) {
    t4 = <Button size="lg" variant={t2} className={className} onClick={t3}>{label}</Button>;
    $[1] = className;
    $[2] = label;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(false);
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== open) {
    t6 = <ContactFormModal open={open} onClose={t5} />;
    $[6] = open;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <>{t4}{t6}</>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}